export const formatPropertyPrice = (value: number | null | undefined, currency: string | null | undefined): string => {
  if (!value || value <= 0) return '—';
  const c = currency ?? 'UF';
  if (c === 'UF') return `UF ${Math.round(value).toLocaleString('es-CL')}`;
  return `${value.toLocaleString('es-CL')} ${c}`;
};
